<template>
  <div class="group-list content-height">
    <div
        v-for="(item, index) in parentGroup"
        :key="item.id"
        class="group-item"
        :class="{ custom_active: selectedGroupId === item.id }"
        @click="handleClick(item)"
    >
      <span class="head-group">
          {{ item.name }}
     </span>
    </div>

  </div>
</template>

<script setup>
const props = defineProps({
  parentGroup: {
    type: Array,
    required: true
  },
  selectedGroupId: {
    type: [Number, String],
    default: null
  }
});

const emit = defineEmits(['selectGroup']);

const handleClick = (item) => {
  emit('selectGroup', item);
};
</script>

<style scoped>
.group-list {
  overflow-y: auto;
  overflow-x: hidden;
}
.group-list::-webkit-scrollbar {
  width: 4px;
}

.group-list::-webkit-scrollbar-track {
  background: transparent;
}

.group-list::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.25);
  border-radius: 10px;
}

.content-height {
  height: 620px;
}

.group-item {
  background: #ffffff;
  border-radius: 12px;
  padding: 12px 14px;
  margin: 8px 2px;
  cursor: pointer;

  display: flex;
  align-items: center;

  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.5);
  transition: all 0.2s ease;
}

.group-item:hover {
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.12);
  transform: translateY(-1px);
  background: #f3f2f7;
}

.group-item.custom_active {
  background: #e1e1e1;
  box-shadow: 0 4px 12px rgba(115, 103, 240, 1.4);
}

.head-group {
  display: block;

  font-size: 24px;
  text-align: center;
  line-height: 80px;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

</style>